
import React from "react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { Control, FieldValues } from "react-hook-form";
import Input from "../../input";
import Card from "../../card";
import Button from "../../button";
import Icon from "../../../assets/icons";
import { CircleLoader } from "react-spinners";

interface ForgotPasswordProps {
  handleForgotPassowrd: (e: React.FormEvent<HTMLFormElement>) => void;
  control: Control<FieldValues>;
  loading: boolean;
}

const ForgotPasswords = ({
  handleForgotPassowrd,
  control,
  loading,
}: ForgotPasswordProps) => {
  return (
    <Card
      title="Forgot Password"
      subtitle="Secure your Account with a Quick Password Reset"
    >
      <form className="mt-6 md:mt-8" onSubmit={handleForgotPassowrd}>
        <div className="flex flex-col gap-4 md:gap-6 mb-5">
          <div className="w-full">
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Enter a valid email. E.g, example@gmail.com",
                },
              }}
              render={({ field, fieldState }) => (
                <Input
                  value={field.value}
                  placeholder="name@example.com"
                  className="w-full "
                  label="Email"
                  icon="emailIcon"
                  error={fieldState?.error?.message}
                  onChange={field.onChange}
                  autoComplete="off"
                />
              )}
            />
          </div>
        </div>
        <div className="flex flex-col justify-center items-center mt-5">
          <Button
            size="lg"
            variant="primary"
            type="submit"
            className="font-normal"
          >
            {loading ? (
              <CircleLoader color="#ffffff" loading={loading} size={20} />
            ) : (
              <div className="flex gap-3">
                Continue <Icon name="signIcon" />
              </div>
            )}
          </Button>

          <Link
            to={"/signin"}
            className="mt-2 text-[#047401] text-[16px] flex gap-2"
          >
            <Icon name="backIcon" /> Back to Sign in screen
          </Link>
        </div>
      </form>
    </Card>
  );
};

export default ForgotPasswords;
